import { MouseEvent } from "react";
import cls from "classnames";
import styles from "./index.module.scss";
import { ReactComponent as CloseIcon } from "../icons/close.svg";

interface IProps {
  text: string;
  className?: string;
  refMode?: boolean;
  important?: boolean;
  onDelete?: () => void;
  onClick?: () => void;
}

const RefText = ({
  text,
  className,
  refMode,
  onDelete,
  onClick,
  important,
}: IProps) => {
  return (
    <div
      onClick={onClick}
      className={cls(
        styles.container,
        important && styles.important,
        onClick && styles.clickable,
        refMode && styles.refMode,
        className,
      )}
    >
      {text}
      {refMode && (
        <CloseIcon
          className={styles.close}
          onClick={(e: MouseEvent) => {
            e.preventDefault();
            e.stopPropagation();
            onDelete?.();
          }}
        />
      )}
    </div>
  );
};

export default RefText;
